import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FilePlus2, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtDate } from "@/lib/api";
import { fmtKwp, fmtMoney } from "@/lib/apolloCalc";

const Row = ({ k, v }) => (
  <div className="flex justify-between gap-4 border-b border-slate-100 py-2 text-sm"><span className="text-slate-500">{k}</span><span className="text-right font-medium text-slate-900">{v || "—"}</span></div>
);

export const LeadDialog = ({ lead, onClose, onSave, onDelete }) => {
  const navigate = useNavigate();
  const [notes, setNotes] = useState("");
  useEffect(() => {
    setNotes(lead?.staff_notes || "");
  }, [lead]);
  if (!lead) return null;
  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="lead-detail-dialog" className="max-h-[90vh] overflow-y-auto sm:max-w-lg">
        <DialogHeader><DialogTitle>{lead.name}</DialogTitle></DialogHeader>
        <div>
          <Row k="Telefono" v={lead.phone} />
          <Row k="Email" v={lead.email} />
          <Row k="Indirizzo" v={lead.address} />
          <Row k="Città / Regione" v={[lead.city, lead.region].filter(Boolean).join(" · ")} />
          <Row k="Stabile" v={lead.building_type} />
          <Row k="Consumo dichiarato" v={lead.consumption_kwh ? `${lead.consumption_kwh} kWh` : "stimato"} />
          <Row k="Impianto" v={`${lead.panels} pannelli · ${fmtKwp(lead.kwp)} kWp · ${lead.feasibility}%`} />
          <Row k="Risparmio stimato" v={lead.savings != null ? `${fmtMoney(lead.savings, lead.currency || "EUR")}/anno` : null} />
          <Row k="Note cliente" v={lead.notes} />
          <Row k="Ricevuto" v={fmtDate(lead.created_at)} />
        </div>
        <label className="mt-2 text-sm font-medium">Note staff</label>
        <textarea data-testid="lead-staff-notes-input" value={notes} onChange={(e) => setNotes(e.target.value)} rows={4}
          className="w-full rounded-xl border border-slate-200 p-3 text-sm outline-none focus:border-emerald-500" placeholder="Esito chiamata, data sopralluogo…" />
        <div className="flex flex-wrap gap-2">
          <button data-testid="lead-save-notes-button" onClick={() => onSave(lead.id, { staff_notes: notes })} className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-500 hover:text-slate-900">Salva note</button>
          <button data-testid="lead-create-quote-button" onClick={() => navigate(`/admin/preventivi/nuovo?lead=${lead.id}`)} className="inline-flex items-center gap-1.5 rounded-xl border border-slate-200 px-4 py-2 text-sm font-medium hover:border-slate-900">
            <FilePlus2 className="h-4 w-4" /> Crea preventivo
          </button>
          <button data-testid="lead-delete-button" onClick={() => window.confirm("Eliminare questo lead?") && onDelete(lead.id)} className="ml-auto inline-flex items-center gap-1.5 rounded-xl px-3 py-2 text-sm text-rose-600 hover:bg-rose-50">
            <Trash2 className="h-4 w-4" /> Elimina
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
